// Slice de UI da feature contacts. Estado de domínio fica no cache do RTK Query.
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface ContactsUiState {
  selectedContactId: string | null;
  isCreating: boolean;
  /** Modal de delete aberta pra qual contato. */
  pendingDeleteId: string | null;
  search: string;
  selectedTags: string[];
  /** Filtro de loja (só GESTOR). 'all' = todas as lojas. */
  storeFilter: string;
  /** LGPD: reexibe os contatos excluídos (anonimizados), fora da lista por padrão. */
  showDeleted: boolean;
}

const initialState: ContactsUiState = {
  selectedContactId: null,
  isCreating: false,
  pendingDeleteId: null,
  search: '',
  selectedTags: [],
  storeFilter: 'all',
  showDeleted: false,
};

const contactsSlice = createSlice({
  name: 'contactsUi',
  initialState,
  reducers: {
    contactSelected(state, action: PayloadAction<{ id: string | null }>) {
      state.selectedContactId = action.payload.id;
    },
    creatingToggled(state, action: PayloadAction<{ on: boolean }>) {
      state.isCreating = action.payload.on;
    },
    deletePending(state, action: PayloadAction<{ id: string | null }>) {
      state.pendingDeleteId = action.payload.id;
    },
    searchChanged(state, action: PayloadAction<{ value: string }>) {
      state.search = action.payload.value;
    },
    tagToggled(state, action: PayloadAction<{ tag: string }>) {
      const idx = state.selectedTags.indexOf(action.payload.tag);
      if (idx === -1) state.selectedTags.push(action.payload.tag);
      else state.selectedTags.splice(idx, 1);
    },
    tagsCleared(state) {
      state.selectedTags = [];
    },
    storeFilterChanged(state, action: PayloadAction<{ storeId: string }>) {
      state.storeFilter = action.payload.storeId;
    },
    showDeletedToggled(state, action: PayloadAction<{ on: boolean }>) {
      state.showDeleted = action.payload.on;
    },
  },
});

export const {
  contactSelected,
  creatingToggled,
  deletePending,
  searchChanged,
  tagToggled,
  tagsCleared,
  storeFilterChanged,
  showDeletedToggled,
} = contactsSlice.actions;

export const contactsUiReducer = contactsSlice.reducer;

type Root = { contactsUi: ContactsUiState };

export const selectContactsUi = (s: Root): ContactsUiState => s.contactsUi;
export const selectSelectedContactId = (s: Root): string | null => s.contactsUi.selectedContactId;
export const selectIsCreatingContact = (s: Root): boolean => s.contactsUi.isCreating;
export const selectPendingDeleteId = (s: Root): string | null => s.contactsUi.pendingDeleteId;
export const selectContactSearch = (s: Root): string => s.contactsUi.search;
export const selectSelectedTags = (s: Root): string[] => s.contactsUi.selectedTags;
export const selectContactStoreFilter = (s: Root): string => s.contactsUi.storeFilter;
export const selectShowDeletedContacts = (s: Root): boolean => s.contactsUi.showDeleted;
